import { DetectionType } from '../../reporter/constants';
import { LegacyEcdn10Data } from '../../priming/interfaces';
import { dispatchPrimingEvent } from '../../events/dispatch';

const handleEcdn10DetectionData = (ecdn10?: LegacyEcdn10Data): void => {
  const data = ecdn10 && ecdn10.detectData;
  if (!data) {
    return;
  }
  const type = DetectionType.ECDN10;
  const { success, failures } = data;
  (failures || []).forEach(({ protocol: method, request, start, t }) => {
    const status = (request as Record<string, unknown>).status;
    dispatchPrimingEvent({ method, t, type, start });
    dispatchPrimingEvent({ method, t, type, status, success: false });
  });
  if (success) {
    const { start, protocol: method, data } = success;
    const { version: v, blackout } = data;
    dispatchPrimingEvent({ method, type, t: start });
    dispatchPrimingEvent({ method, type, blackout, success: true, v });
  }
};

export default handleEcdn10DetectionData;
